import script from "./headermenu.vue?vue&type=script&setup=true&lang=js"
export * from "./headermenu.vue?vue&type=script&setup=true&lang=js"

import "./headermenu.vue?vue&type=style&index=0&id=62301e83&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62301e83"]])

export default __exports__